import React from "react";
import App from "../../App";

function Entry() {
  return <App />;
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <p>Hello, this is the root page of your app</p>
    </div>
  );
}

export default Entry;
